module.exports = __webpack_public_path__ + "static/media/music-player.daadb599.png";